import { useApiMutation } from '@/composables/useApi';
import { phoneValidationEndpoints } from '@/services/api/apiConfig';
import type {
  PhoneValidationRequest,
  PhoneValidationResponse,
} from '@/domains/auth/types/PhoneValidation';

export const usePhoneValidationMutation = () =>
  useApiMutation<PhoneValidationResponse, Error, PhoneValidationRequest>({
    endpoint: phoneValidationEndpoints.VALIDATE(''),
    method: 'get',
    mapVariablesToRequest: ({ uuid, phoneNumber }) => ({
      endpoint: phoneValidationEndpoints.VALIDATE(uuid),
      queryParams: { phoneNumber },
    }),
  });
